import React, { useState, useEffect } from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import Sidebar from "./Sidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_URL from "../config/api";

const AdminUserList = () => {
    const [userData, setUserData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const itemsPerPage = 50;
    const [error, setError] = useState();

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${API_URL}/admin/users/get_users.php`
            );

            const data = await response.json();

            setUserData(data);
        } catch (err) {
            console.error(err);
            setError("Unable to load users.");
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    // Verify user
    const handleVerify = async (id, verified) => {
        try {
            const response = await fetch(`${API_URL}/admin/users/verify_user.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id,
                        isAdminVerified: verified ? 1 : 0,
                    }),
                }
            );

            const result = await response.json();

            if (result.success) {
                toast.success("User verified successfully.");
                fetchUsers(); // Refresh the table
            } else {
                toast.error(result.message);
            }
        } catch (err) {
            console.error(err);
            toast.error("Server error.");
        }
    };

    const filteredData = userData.filter((details) => {
        const regex = new RegExp(searchTerm, "i");
        return (
            regex.test(String(details.id)) ||
            regex.test(details.username || "") ||
            regex.test(details.email || "") ||
            regex.test(details.role || "") ||
            regex.test(String(details.isAdminVerified))
        );
    });

    const lastIndex = currentPage * itemsPerPage;
    const firstIndex = lastIndex - itemsPerPage;
    const currentData = filteredData.slice(firstIndex, lastIndex);

    const totalPageCount = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div className='app'>
            <Sidebar />
            <section className='userlist-section'>
                <div className="container"><br /><br /><br />
                    <h2 className='overview13'>Users:</h2>
                    <div className="row justify-content-start">
                        <div className="col" id='qrtable'>
                            <Form.Group controlId="search">
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </Form.Group>
                            <div className="table-responsive">
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Username</th>
                                            <th className="d-none d-md-table-cell">Email</th>
                                            <th className="d-none d-md-table-cell">Role</th>
                                            <th className="d-none d-md-table-cell">KYC Verification</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.map((data) => (
                                            <tr key={data.id}>
                                                <td>{data.id}</td>
                                                <td>{data.username}</td>
                                                <td className="d-none d-md-table-cell">{data.email}</td>
                                                <td className="d-none d-md-table-cell ">{data.role}</td>
                                                <td className="d-none d-md-table-cell ">{data.isAdminVerified ? "Verified" : "Not Verified"}</td>
                                                <td>
                                                    <button onClick={() => handleVerify(data.id, true)} disabled={data.isAdminVerified}>
                                                        {!data.isAdminVerified ? "Verify User" : "Verified"} </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>


                            <div style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>
                                <Pagination>
                                    {Array.from({ length: totalPageCount }, (_, index) => (
                                        <Pagination.Item
                                            key={index + 1}
                                            active={index + 1 === currentPage}
                                            onClick={() => setCurrentPage(index + 1)}
                                        >
                                            {index + 1}
                                        </Pagination.Item>
                                    ))}
                                </Pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {error && <p className="error">{error}</p>}
            {/* ToastContainer for displaying Toast notifications */}
            <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

export default AdminUserList;
